import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { getUserProfile } from "../../Common/data/getUserProfile";

// Define an interface for the Moodle user data
interface MoodleUserData {
  mooduleUserName: string;
  mooduleLoginPassword: string;
}

const SuccessInfo: React.FC = () => {
  const [moodleUserData, setMoodleUserData] = useState<MoodleUserData | null>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const profile = await getUserProfile();

        // Access the user data wrapped in the results object
        const { mooduleUserName, mooduleLoginPassword } = profile.results;

        console.log("hello", profile.results);

        if (mooduleUserName && mooduleLoginPassword) {
          setMoodleUserData({ mooduleUserName, mooduleLoginPassword });
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchProfile();
  }, []);

  // Conditionally render the card only if moodleUserData is available
  if (!moodleUserData) {
    return null; // Render nothing if moodleUserData is null
  }

  return (
    <Card className="mb-4">
      <Card.Body>
        <h6 className="mb-4">LMS Info</h6>
        <p>You have passed and can <a href="https://lms.atcef.com/" target="_blank" rel="noopener noreferrer">log in</a> with your LMS credentials.</p>
        <Row className="mb-3">
          <Col>
            <p><strong>Username:</strong> {moodleUserData.mooduleUserName}</p>
          </Col>
          <Col>
            <p><strong>Password:</strong> {moodleUserData.mooduleLoginPassword}</p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SuccessInfo;
